export default {
special_attraction_pairs:
  {"entity_9578": require('./images/attractions/sf_attraction_winery.jpg'),
  "entity_7714":
  require('./images/attractions/sf_attraction_sci.jpg'),
  "entity_7272":
  require('./images/attractions/sf_attraction_pier39.jpg'),
  "entity_10269":
  require('./images/attractions/sf_attraction_cinema1.jpg'),
  "entity_1397":
  require('./images/attractions/sf_attraction_cinema2.jpg'),
  "entity_8307":
  require('./images/attractions/sf_attraction_attpark.jpg'),
  "entity_9094":
  require('./images/attractions/sf_attraction_exploratorium.jpg'),
  "entity_1784":
  require('./images/attractions/sf_attraction_alcatraz.jpg'),
  "entity_7701":
  require('./images/attractions/sf_attraction_zoo.jpg')
  }
}
